module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-tab"
  }, [(!_vm.hasTabSlot) ? _c('nav-tabs', {
    attrs: {
      "tabs": _vm.tabs
    },
    on: {
      "onTabClick": _vm.onTabClick
    }
  }) : _vm._e(), _vm._t("tab"), _c('div', {
    staticClass: "tab-content"
  }, [(!_vm.hasTabContent) ? _vm._t("default") : _vm._e(), _vm._t("content")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2825bacd","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/mdTab/index.vue
// module id = 1518
// module chunks = 0